<div [ngClass]="{'location-not-found':isLocationFeature}">
  <div class="component-test" [ngClass]="{'noTitle':title ==''}">

    <div class="input-group-prepend">
      @if (title!=='') {
        <span class="input-group-text">{{title}}:</span>
      }
    </div>

    <div class="input-field">
      <input type="text" class="form-control plan-input-group" [class.is-invalid]="searchFailed"
        placeholder="{{!isLocationFeature ? placeHolder: ''}}"
        #instance="ngbTypeahead"
        #elem
        [(ngModel)]="locationSearchTerm"
        [focusFirst]=false
        [ngbTypeahead]="search"
        [inputFormatter]="typeaheadFormatter"
        [resultFormatter]="typeaheadFormatter"
        (mousedown)="highlightText($event)"
        (touchstart)="highlightText($event)"
        (selectItem)="selectedItem($event.item)"
        (keydown)="onKeydown($event)"
        (focus)="onFocus()"
        (input)="onInputHandler($event.srcElement.value)"
        (blur)="onBlurFocus(locationModel)" />
      </div>

      @if (useCurrentLocationIcon) {
        <div class="tooltips">
          <img src="./assets/icons/svg/icon-locate.svg" alt="Current location" class="locate" (click)="useCurrentLocation()" (keyup.enter)="useCurrentLocation()" tabindex="0"  aaNoDblClick/>
          <span class="tooltiptext">Current location</span>
        </div>
      }

      @if (searchFailed) {
        <div class="invalid-feedback" [innerHTML]="APP_GOOGLE_PLACE_NOTFOUND"></div>
      }
    </div>

    @if (isLocationFeature) {
      <div >
        <span class="alert-close">x</span>
        <span class="turn-on-location-placeholder">{{locationModel.errorMessage}}</span>
      </div>
    }
  </div>
